module.exports = __webpack_public_path__ + "img/banner.9f8e9bab.jpg";